module.exports = __webpack_public_path__ + "img/zora.46179446.png";